import { vm }  from '@/main.js';

const jsonResult = (field, boolean) => {
	return {
		field,
		boolean
	}
}
const structureBasic = class structureBasic {

	constructor(question) {
		const { name, type, label, required, inputType } = question;
		if(name.length < 3) return jsonResult('name',false);
		if(type.length < 3) return jsonResult('type',false);
		if(label.length < 3) return jsonResult(vm.$t(`MODULE.emptyLabel`),false);
		if(required === null || required === undefined) return jsonResult('required',false);
		if(inputType.length < 3) return jsonResult('inputType',false);
		return jsonResult('none',true);
	}
}

const Options = class Options extends structureBasic {
	constructor(question) {
		const result = super(question);
		if(!result.boolean) return  result;
		if(question.options.length === 0) return  jsonResult(vm.$t(`MODULE.emptyOption`),false);
		return  jsonResult('none',true);
	}
}

const Content = class Content extends structureBasic {
	constructor(question) {
		const result = super(question);
		if(!result.boolean) return  result;
		if(question.content.length < 3) return jsonResult(vm.$t(`MODULE.requiredUrl`),false);
		return  jsonResult('none',true);
	}
}

const Subform = class Subform extends structureBasic {
	constructor(question) {
		const result = super(question);
		if(!result.boolean) return  result;

		if(question.inherited.length === 0) return jsonResult(vm.$t(`MODULE.requiredSubform`),false);
		return  jsonResult('none',true);

	}
}

const DataSource = class DataSource extends structureBasic {
	constructor(question) {
		const result = super(question);
		if(question.inputType === 'select' || question.inputType === 'database') {
			if(question.query.q.length === 0) return jsonResult(vm.$t(`MODULE.requiredFql`),false);
			if(question.query.action.length === 0) return jsonResult(vm.$t(`MODULE.requiredType`),false);
			if(question.query.action === 'trigger') return;
		}

		if(question.hasOwnProperty('data'))	{
			if(question.data.length === 0 ) return jsonResult(vm.$t(`MODULE.requiredOriginData`),false);
			if(question.properties.searchField.length === 0 && question.inputType !=='select') return jsonResult(vm.$t(`MODULE.RequiredMainField`),false);
		}

	}
}

const Listinformative = class Listinformative extends structureBasic {
	constructor(question) {
		const result = super(question);
		if(question.data.length === 0) return jsonResult(vm.$t(`MODULE.requiredListData`),false);
		return  jsonResult('none',true);
	}
}

const Actions = class Actions extends structureBasic {
	constructor(question) {
		const result = super(question);
		if(question.actions.questions.length === 0) return jsonResult(vm.$t(`MODULE.requiredQuestionsToActions`),false);
		if(question.actions.operation === 'mode' && question.actions.questions.length < 3) return jsonResult(vm.$t(`MODULE.maxQuestionMode`),false);
		// if(question.actions.questions.length < 2) return jsonResult(vm.$t(`MODULE.maxQuestionsToActions`),false);
		return  jsonResult('none',true);
	}
}

const ValidateQuestion = (question) => {
	let result = new structureBasic(question);

	if(!result.boolean) return result;

	if(question.hasOwnProperty('options')) {
		result = new Options(question);
		if(!result.boolean) return result;
	}

	if(question.hasOwnProperty('content')) {
		result = new Content(question);
		if(!result.boolean) return result;
	}

	if(question.hasOwnProperty('inherited')) {
		if(question.type === 'subform') {
			result = new Subform(question);
			if(!result.boolean) return result;
		}
	}

	if(question.inputType === 'flex') {
		if(question.inherited.length === 0) {
			return jsonResult(vm.$t(`MODULE.requiredSelectMutipleToFlex`),false);
		}
	}

	if(question.hasOwnProperty('inherited')) {
		if(question.type === 'subform') {
			result = new Subform(question);
			if(!result.boolean) return result;
		}
	}

	if(question.type === 'datasource') {
		result = new DataSource(question);
		if(!result.boolean) return result;
	}

	if(question.hasOwnProperty('data')) {
		result = new Listinformative(question);
		if(!result.boolean) return result;
	}

	if(question.hasOwnProperty('actions')) {
		result = new Actions(question);
		if(!result.boolean) return result;
	}
	return result;
}

export { ValidateQuestion };
